import {Injectable} from '@angular/core';

@Injectable()
export class StringUtil {
    private static readonly MaskCharacter = 'X';
    private static readonly PhoneNumberSuffixLength = 5;

    public maskPhoneNumber(phoneNumber: string): string {
        const suffix = phoneNumber.substring(phoneNumber.length - StringUtil.PhoneNumberSuffixLength, phoneNumber.length);
        const maskedCharacterLength = phoneNumber.length - 5;

        let maskedPhoneNumber = '';
        for (let index = 0; index < maskedCharacterLength; index++) {
            maskedPhoneNumber = maskedPhoneNumber.concat(StringUtil.MaskCharacter);
        }
        return maskedPhoneNumber.concat(suffix);
    }
}
